var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowRightTopFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.1826C12.0869 15.1826 15.4707 11.7915 15.4707 7.71191C15.4707 3.625 12.0796 0.241211 7.99268 0.241211C3.91309 0.241211 0.529297 3.625 0.529297 7.71191C0.529297 11.7915 3.92041 15.1826 8 15.1826ZM10.3584 9.58691C10.0215 9.58691 9.80176 9.35254 9.80176 8.99365V7.69727L9.91162 6.51807L8.82031 7.68262L6.05908 10.4512C5.94189 10.561 5.80273 10.627 5.61963 10.627C5.29004 10.627 5.06299 10.4072 5.06299 10.063C5.06299 9.9165 5.13623 9.7627 5.24609 9.65283L8.02197 6.88428L9.20117 5.78564L8.08057 5.90283H6.71826C6.35205 5.90283 6.11768 5.68311 6.11768 5.35352C6.11768 5.0166 6.34473 4.79688 6.70361 4.79688H10.2778C10.666 4.79688 10.915 4.97266 10.915 5.41943V8.979C10.915 9.33057 10.688 9.58691 10.3584 9.58691Z",
    fill: "#878793"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightTopFilled);
export default __webpack_public_path__ + "static/media/icon-arrow-right-top-filled.d6b55d6e9e0a18aeaf06574514f7dd47.svg";
export { ForwardRef as ReactComponent };